var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("CargoMsg.Cargo_Prompt"),
        width: "500px",
        "close-on-press-escape": false,
        "close-on-click-modal": false,
        "append-to-body": true
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("div", { staticStyle: { "margin-left": "30px" } }, [
        _c(
          "p",
          { staticStyle: { "font-size": "20px", "font-weight": "bold" } },
          [_vm._v(_vm._s(this.$t("SeaExport.SyncContainerInfoContent")))]
        ),
        _c(
          "p",
          { staticStyle: { "margin-left": "40px", "font-size": "16px" } },
          [_vm._v(_vm._s(_vm.quantityTip))]
        ),
        _c(
          "p",
          { staticStyle: { "margin-left": "40px", "font-size": "16px" } },
          [_vm._v(_vm._s(_vm.weightTip))]
        ),
        _c(
          "p",
          { staticStyle: { "margin-left": "40px", "font-size": "16px" } },
          [_vm._v(_vm._s(_vm.cubageTip))]
        )
      ]),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", no: "ok" },
              on: {
                click: function($event) {
                  return _vm.ok()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.ok")))]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }